<div class="embed-responsive embed-responsive-1by1">
    <iframe class="embed-responsive-item" src="https://datastudio.google.com/u/1/reporting/239eb703-3f5d-4363-a8e3-082c8014bcd1/page/vPgaB"></iframe>
  </div>